import { InputAdornment } from '@mui/material';
import { IdentificationIcon } from '@heroicons/react/outline';
import { ITextInputProps, TextInput } from '../TextInput';
import { SSNMask } from './SSNMask';

export const SSNInput = (props: ITextInputProps) => (
  <TextInput
    {...props}
    fullWidth
    InputProps={{
      inputComponent: SSNMask,
      endAdornment: (
        <InputAdornment position="end">
          <IdentificationIcon width={24} />
        </InputAdornment>
      ),
    }}
  />
);
